import { z } from 'zod';

// Lives in its own module (not flow.ts) because manual trigger NODES embed
// input fields in their config: nodes.ts needs this schema, and flow.ts
// already imports nodes.ts, so defining it in flow.ts would create a cycle.

export const FlowInputFieldTypeSchema = z.enum(['string', 'number', 'boolean', 'url', 'text']);
export type FlowInputFieldType = z.infer<typeof FlowInputFieldTypeSchema>;

export const FlowInputFieldSchema = z.object({
  name: z.string().min(1),
  type: FlowInputFieldTypeSchema,
  label: z.string().optional(),
  description: z.string().optional(),
  required: z.boolean().optional().default(false),
  defaultValue: z.union([z.string(), z.number(), z.boolean()]).optional(),
});
export type FlowInputField = z.infer<typeof FlowInputFieldSchema>;
